module.exports = __webpack_public_path__ + "img/PR0616.12f228bf.png";